import { useState, useEffect } from "react";

function convertToFlag(countryCode) {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

export function useFetchWeather(location) {
  const [displayLocation, setDisplayLocation] = useState("");
  const [weather, setWeather] = useState({});
  const [isloading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(
    function () {
      const controller = new AbortController();

      if (location.length < 2) {
        setWeather({});
        setError("");
        return;
      }

      async function fetchWeather() {
        // if (location.length < 2) return setWeather({});

        try {
          setIsLoading(true);
          setError("");
          setDisplayLocation("");
          setWeather({});

          // 1) Getting location (geocoding)
          const geoRes = await fetch(
            `https://geocoding-api.open-meteo.com/v1/search?name=${location}`,
            { signal: controller.signal }
          );

          if (!geoRes.ok)
            throw new Error("Something went wrong with fetching location!");

          const geoData = await geoRes.json();
          console.log(geoData);

          if (!geoData.results) throw new Error("Location not found!");

          const { latitude, longitude, timezone, name, country_code } =
            geoData.results.at(0);

          setDisplayLocation(`${name} ${convertToFlag(country_code)}`);

          // 2) Getting actual weather
          const weatherRes = await fetch(
            `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&timezone=${timezone}&daily=weathercode,temperature_2m_max,temperature_2m_min`
          );

          if (!weatherRes.ok)
            throw new Error("Something went wrong with fetching weather!");

          const weatherData = await weatherRes.json();
          console.log(weatherData.daily);

          if (!weatherData.daily) throw new Error("weather not found!");

          setWeather(weatherData.daily);
          setError("");
        } catch (err) {
          if (err.name !== "AbortError") {
            console.log(err.message);
            setError(err.message);
          }
        } finally {
          setIsLoading(false);
        }
      }

      fetchWeather();

      return function () {
        controller.abort();
      };
    },
    [location]
  );

  return { displayLocation, weather, isloading, error };
}
